/**
 * Referentiedata: de musea zelf. Wordt bij de build meegeleverd (src/data/museums.json),
 * gegenereerd door scripts/import-musea.mjs. Nooit door de gebruiker bewerkt.
 */

export const PROVINCIES = [
  'Groningen', 'Friesland', 'Drenthe', 'Overijssel', 'Flevoland', 'Gelderland',
  'Utrecht', 'Noord-Holland', 'Zuid-Holland', 'Zeeland', 'Noord-Brabant', 'Limburg',
] as const;
export type Provincie = (typeof PROVINCIES)[number];

export const CATEGORIEEN = ['kunst', 'geschiedenis', 'wetenschap', 'techniek', 'cultuur'] as const;
export type Categorie = (typeof CATEGORIEEN)[number];

export interface Museum {
  /** Stabiel ID (slug). Gebruikersgegevens hangen hieraan, dus het verandert nooit. */
  id: string;
  naam: string;
  plaats: string;
  provincie: Provincie;
  adres?: string;
  postcode?: string;
  lat: number;
  lng: number;
  categorie: Categorie;
  omschrijving?: string;
  website?: string;
  /** Normale toegangsprijs volwassene in eurocent (voor de terugverdienteller). */
  prijs?: number;
  /** Toeslag of verplicht tijdslot reserveren met de Museumkaart. */
  reserveren?: boolean;
  /** Gemiddelde beoordeling (1–5) en aantal reviews op Google, volgens de bron-sheet. */
  beoordeling?: number;
  reviews?: number;
  /** Wikidata-ID (Q…), voor latere verrijking. */
  wikidata?: string;
  /** Wikipedia-artikel waar de omschrijving vandaan komt (CC BY-SA: bronvermelding verplicht). */
  wikipedia?: string;
}

export interface MuseumDataset {
  /** Datum van de laatste import (ISO). */
  bijgewerkt: string;
  /** Waar de data vandaan komt, voor de bronvermelding. */
  bron: string;
  /** true zolang dit nog de handgemaakte voorbeeldset is. */
  voorbeeld: boolean;
  musea: Museum[];
}
